import { DEFAULT_APP_COLOR, DEFAULT_APP_ICONE } from 'core/constants/general'
import { IApplication } from 'core/interfaces/Application'
import { IServiceGroupedApplications } from 'core/interfaces/Service'
import { PERIOD } from 'core/constants/period'
import { add, startOfMonth, startOfWeek, sub } from 'date-fns'

export const getIconeInfo = (iconInfo: string | null | undefined) => {
  const defaultIcon = {
    colorIcon: '#FFFFFF',
    colorBackground: DEFAULT_APP_COLOR,
    svg: DEFAULT_APP_ICONE,
  }

  if (!iconInfo) {
    return defaultIcon
  }

  try {
    const parsedIcon = JSON.parse(iconInfo)
    if (
      parsedIcon &&
      parsedIcon.colorIcon &&
      parsedIcon.colorBackground &&
      parsedIcon.svg
    ) {
      return parsedIcon
    } else {
      return defaultIcon
    }
  } catch (error) {
    return defaultIcon
  }
}

export const groupByService = (applications: IApplication[]) => {
  return applications.reduce((acc, app) => {
    const serviceName = app.service.nomService
    const serviceIcone = getIconeInfo(app.service.icone)
    const newAcc = { ...acc }
    if (!newAcc[serviceName]) {
      newAcc[serviceName] = {
        serviceIcon: app.service.icone,
        service: serviceIcone,
        apps: [],
      }
    }
    newAcc[serviceName].apps.push(app)

    return newAcc
  }, {} as IServiceGroupedApplications)
}

export const getPeriodDates = (
  period: string,
  currentDate: Date
): [Date, Date] => {
  const periodMap = {
    [PERIOD.HEBDO]: [
      startOfWeek(currentDate, { weekStartsOn: 1 }),
      add(startOfWeek(currentDate, { weekStartsOn: 1 }), { days: 6 }),
    ],
    [PERIOD.MENSUELLE]: [
      startOfMonth(currentDate),
      add(startOfMonth(currentDate), { months: 1, days: -1 }),
    ],
    [PERIOD.SEMESTRIELLE]: [add(currentDate, { months: -5 }), currentDate],
    [PERIOD.ANNUELLE]: [sub(currentDate, { months: 12 }), currentDate],
  } as Record<string, [Date, Date]>
  return periodMap[period] ?? [currentDate, currentDate]
}

export const getLastApplications = (
  apps: IApplication[],
  nbApp: number = 3
): IApplication[] => {
  return [...apps]
    .sort(
      (a, b) =>
        new Date(b.dateCreation).getTime() - new Date(a.dateCreation).getTime()
    )
    .slice(0, nbApp)
}

export const extractCSV = (message: string): string => {
  const csvBlockRegex = /```csv\s*([\s\S]*?)```/i
  const csvOnlyRegex = /```([\s\S]*?)```/i

  let match = message.match(csvBlockRegex)

  if (match && match[1]) {
    return match[1].trim()
  }

  match = message.match(csvOnlyRegex)

  if (match && match[1]) {
    return match[1].trim()
  }

  return message.trim()
}
